<template>
  <Background :bgColor="dataComp.bgColor" :bgImage="dataComp.bgImage">
    <Container>
      <Cta
        :layout="dataComp.layout"
        :button="dataComp.button"
        :image="dataComp.image"
        :centerText="dataComp.centerText"
        :titleText="dataComp.title"
        :bodyText="dataComp.body">
      </Cta>
    </Container>
  </Background>
</template>

<script>
import useHasSlot from "../../compostables/useHasSlot";
import Background from "../Atoms/Background.vue";
import Container from "../Atoms/Container.vue";
import Cta from "../Modules/Cta.vue";

export default {
  components: {
    Background,
    Cta,
    Container,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  setup(props, { slots }) {
    const { hasSlot } = useHasSlot(slots);
    let dataComp = {
      bgColor: props.data.backgroundColor,
    };

    const getImageDetails = (element) => {
      if (element) {
        return {
          src: element.image,
          alt: element.description,
        };
      }

      return null;
    };

    if (props.data.button) {
      dataComp["button"] = {
        tag: props.data.button.buttonType,
        style: props.data.button.buttonStyle,
        link: props.data.button.url,
        text: props.data.button.buttonText,
      };
    }

    switch (props.data.imagePosition) {
      case "right":
        dataComp["layout"] = props.data.button ? "body-btn-img" : "body-img";
        dataComp["image"] = getImageDetails(props.data.image);
        break;

      case "left":
        dataComp["layout"] = props.data.button ? "img-body-btn" : "img-body";
        dataComp["image"] = getImageDetails(props.data.image);
        break;

      case "background":
        dataComp["layout"] = "body-btn";
        dataComp["bgImage"] = props.data.image.image;
        dataComp["centerText"] = true;
        break;

      case "no image":
        dataComp["layout"] = "body-btn";
        break;
    }

    dataComp["title"] = props.data.title;
    dataComp["body"] = props.data.body;

    return {
      hasSlot,
      dataComp,
    };
  },
};
</script>

<style></style>
